/*
  Licensed under the Apache License, Version 2.0 (the "License"); you may not use
  this file except in compliance with the License. You may obtain a copy of the
  License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software distributed
  under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
  CONDITIONS OF ANY KIND, either express or implied. See the License for the
  specific language governing permissions and limitations under the License.
*/

// Fallback floor for a YEAR_RANGE control when no explicit `minYear` is
// configured: the admin shows it as the default in the layer config, and the map
// legend uses it as the slider's lower bound. Shared so both stay in sync.
export const DEFAULT_YEAR_RANGE_MIN: number = Number(
  process.env.VITE_APP_INTERACTIVE_LEGEND_YEAR_RANGE_MIN || 1500
);

// A YEAR_RANGE control's bounds, with a blank one falling back to `fallback`,
// by default the system floor or the current year.
const parseYear = (value?: string | number): number | undefined => {
  const year = parseInt(String(value), 10);
  return Number.isNaN(year) ? undefined : year;
};

export const yearRangeMin = (
  minYear?: string | number,
  fallback: number = DEFAULT_YEAR_RANGE_MIN
): number => parseYear(minYear) ?? fallback;

export const yearRangeMax = (
  maxYear?: string | number,
  fallback: number = new Date().getFullYear()
): number => parseYear(maxYear) ?? fallback;
